import { defineMessages } from 'react-intl';

type MessageKeys = 'success' | 'loading' | 'error' | 'info' | 'warning' | 'discovery' | 'todo';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		success: {
			id: 'ai-mate.loading-status-indicator.success',
			defaultMessage: 'Success',
			description:
				'Status label text displayed in a loading status indicator component within the AI conversation interface, indicating that an operation has completed successfully. Shown as text in a status badge or indicator. The purpose is to clearly communicate that a process or action has finished successfully.',
		},
		loading: {
			id: 'ai-mate.loading-status-indicator.loading',
			defaultMessage: 'Loading',
			description:
				'Status label text displayed in a loading status indicator component within the AI conversation interface, indicating that an operation is currently in progress. Shown as text in a status badge or indicator. The purpose is to clearly communicate that a process or action is still being executed.',
		},
		error: {
			id: 'ai-mate.loading-status-indicator.error',
			defaultMessage: 'Error',
			description:
				'Status label text displayed in a loading status indicator component within the AI conversation interface, indicating that an operation has failed or encountered an error. Shown as text in a status badge or indicator. The purpose is to clearly communicate that a process or action has encountered a problem.',
		},
		info: {
			id: 'ai-mate.loading-status-indicator.info',
			defaultMessage: 'Information',
			description:
				'Status label text displayed in a loading status indicator component within the AI conversation interface, indicating an informational status or message. Shown as text in a status badge or indicator. The purpose is to clearly communicate informational content or status updates.',
		},
		warning: {
			id: 'ai-mate.loading-status-indicator.warning',
			defaultMessage: 'Warning',
			description:
				'Status label text displayed in a loading status indicator component within the AI conversation interface, indicating a warning condition that requires attention. Shown as text in a status badge or indicator. The purpose is to clearly communicate that there is a potential issue or condition that users should be aware of.',
		},
		discovery: {
			id: 'ai-mate.loading-status-indicator.discovery',
			defaultMessage: 'Discovery',
			description:
				"Status label text displayed in a loading status indicator component within the AI conversation interface, indicating that the AI assistant is in a discovery phase, searching for information or exploring data. Shown as text in a status badge or indicator. The purpose is to clearly communicate that the AI is actively researching or discovering information to answer the user's query.",
		},
		todo: {
			id: 'ai-mate.loading-status-indicator.todo',
			defaultMessage: 'To do',
			description:
				'Status label text displayed in a loading status indicator component within the AI conversation interface, indicating that a task or step is pending and needs to be completed. Shown as text in a status badge or indicator. The purpose is to clearly communicate that an action or step is queued and waiting to be executed.',
		},
	});

export default message;
